const state = {
  listaTiposDocumentais: [],
  idTipoSelecionado: undefined
}

export default state
